// LandingPage.js
import React from 'react';
import Header from '../components/header/Header';
import Footer from '../components/footer/Footer';
import SafetyGuidelines from '../components/safety-guidelines/SafetyGuidelines';

const SafetyGuidelinesPage = () => {
  return (
    <div>
      <Header />
      <SafetyGuidelines />
      <Footer />
    </div>
  );
};

export default SafetyGuidelinesPage;
